import SJSpace from '@/components/SJSpace'
import { useLocation } from 'react-router-dom'
import './index.less'

type State = { id: string }
const Question = () => {
  document.title = '问题详情'
  const { state } = useLocation() as { state: State }
  const { id } = state
  console.log(id)
  return (
    <div className="page question">
      <div className="main">
        <SJSpace height={40} />
        {id === '1' ? (
          <Q1 />
        ) : id === '2' ? (
          <Q2 />
        ) : id === '3' ? (
          <Q3 />
        ) : id === '4' ? (
          <Q4 />
        ) : id === '5' ? (
          <Q5 />
        ) : id === '6' ? (
          <Q6 />
        ) : undefined}
      </div>
    </div>
  )
}

const Q1 = () => {
  return (
    <>
      <div className="h1">安卓手机获取不到Wi-Fi？</div>
      <div className="section">
        <div className="p">确保手机开启定位（有精确定位也要开启），并且小程序获取定位信息。</div>
        <div className="p">确保开启了手机设置的Wi-Fi。</div>
        <div className="p">如果还是难以获取，请手动输入。</div>
      </div>
    </>
  )
}
const Q2 = () => {
  return (
    <>
      <div className="h1">iOS手机获取不到Wi-Fi？</div>
      <div className="section">
        <div className="p">
          因系统问题，本方法在 iOS 11.0 及 11.1 两个版本失效。微信小程序未支持。
        </div>
        <div className="p">其它系统需要开启位置定位。</div>
        <div className="p">
          跳转到设置之后，请手动进入Wi-Fi列表的设置界面，获取Wi-Fi，再跳转回小程序。
        </div>
        <div className="p">如果还是难以获取，请手动输入。</div>
      </div>
    </>
  )
}
const Q3 = () => {
  return (
    <>
      <div className="h1">获取到Wi-Fi列表但是没有想要连接的Wi-Fi？</div>
      <div className="section">
        <div className="p">可以重新点击获取Wi-Fi，等待Wi-Fi列表完全获取。</div>
        <div className="p">如果还是难以获取，请手动输入。</div>
      </div>
    </>
  )
}
const Q4 = () => {
  return (
    <>
      <div className="h1">二维码无效？</div>
      <div className="section">
        <div className="p">确保扫描区域内只有一个正确的二维码，容易误扫。</div>
      </div>
    </>
  )
}
const Q5 = () => {
  return (
    <>
      <div className="h1">如何与机器人对话？</div>
      <div className="section">
        <div className="p">
          按住棋盘上的【OK】，可与机器人对话，【返回】可打断播报，智能语音交互主要内容包括：
        </div>
      </div>
      <div className="section">
        <div className="h3">象棋知识与规则</div>
        <div className="p">
          棋子和兵种介绍：兵、卒、炮、车（ju）、马、象、士、将、帅的介绍与走法规则
        </div>
        <div className="p">
          招式与杀技说明：什么是当头炮、仙人指路、挺兵局、连环马、过宫炮、士角炮、金钩炮、巡河炮、龟背炮、过河炮、九尾龟、铁滑居、下马威、窝心马、屏风马、担子炮、天地炮、单提马、反宫马、拐角马、先锋马、五六炮、五七炮、盘头马、两头蛇、横车（ju）、直车、骑河车、巡河车、三步虎、卧槽马、重（chong）炮、闷宫、马后炮、双车错杀、钓鱼马、拔簧马、立马车、白马现蹄、双马饮泉、金钩马、挂角马、侧面虎、八角马、空头炮、夹车炮、车炮抽杀、炮碾丹砂、困毙、闷杀、二鬼拍门、送佛归殿、海底捞月、双照僵、三子归边、铁门栓、大胆穿心
        </div>
        <div className="p">
          规则说明：什么是楚河汉界、老将为什么不可以出九宫、有多少个棋子、为什么会和棋、长捉、长将判和或长将判负
        </div>
      </div>
      <div className="section">
        <div className="h3">闲聊与陪伴</div>
        <div className="p">
          介绍类：你的家人在哪、你的年龄、你是男孩女孩、你的名字、象棋水平如何、下象棋的好处有哪些、介绍产品功能、你从哪来、你吃饭睡觉吗、你的大脑是由什么组成的、你的智商高不高、你为什么只有一只手、你上不上学等
        </div>
        <div className="p">
          陪伴类：打招呼说你好、交个朋友、你在不在、告别、早安、晚安、心情如何、变个形给我看看、能在屏幕上画画吗、等等我、陪我聊会儿天、陪我一起笑、陪我写作业等、陪我唱歌、给妈妈打电话、让让我、求表扬夸夸我、你认不认识我等
        </div>
        <div className="p">
          益智类：给我讲象棋故事、教教我象棋口诀、象棋起源、象棋是谁发明的、象棋名家都有谁、讲个笑话、出个脑筋急转弯等
        </div>
      </div>
      <div className="section">
        <div className="h3">功能与命令</div>
        <div className="p">支持部分功能指令，如大点声、小点声、返回上一级、返回主菜单</div>
      </div>
    </>
  )
}
const Q6 = () => {
  return (
    <>
      <div className="h1">利用手机热点，设备无法联网？</div>
      <div className="section">
        <div className="p">iOS 操作系统建议开启“最高兼容性”</div>
        <div className="p">Android 操作系统建议使用2.4 GHz的AP频段</div>
      </div>
    </>
  )
}

export default Question
